export default "__VITE_ASSET__Cbgonlru__"